import { motion } from 'framer-motion';
import type { ReactNode } from 'react';

import { DEFAULT_GREETING_MESSAGE, GREETING_TITLE } from './constants';
import { getFadeScaleMotionProps, getFadeUpMotionProps } from './motion';
import { NovaBackgroundBlob } from './nova-empty-state-art';

interface CustomGreetingProps {
  descriptionId: string;
  icon: ReactNode;
  message?: string;
  prefersReducedMotion: boolean;
  titleId: string;
}

export function CustomGreeting({ descriptionId, icon, message, prefersReducedMotion, titleId }: CustomGreetingProps) {
  return (
    <section
      aria-describedby={descriptionId}
      aria-labelledby={titleId}
      className="mx-auto flex size-full max-w-3xl flex-col items-center justify-center px-8 text-center"
      data-testid="nova-empty-state"
    >
      <motion.div
        className="relative flex flex-col items-center"
        data-testid="nova-empty-state-frame"
        {...getFadeScaleMotionProps(prefersReducedMotion)}
      >
        <NovaBackgroundBlob
          className="absolute top-[30px] w-[280px] rotate-[5.89deg]"
          data-testid="nova-empty-state-blob"
        />

        <div
          aria-hidden="true"
          className="relative z-10 flex size-[90px] items-center justify-center"
          data-testid="nova-empty-state-icon"
        >
          {icon}
        </div>

        <motion.h2
          className="relative z-10 mb-2 text-[17px] leading-6 font-semibold text-[#262D46]"
          data-testid="nova-empty-state-title"
          id={titleId}
          {...getFadeUpMotionProps(prefersReducedMotion, 0.5)}
        >
          {GREETING_TITLE}
        </motion.h2>

        <motion.p
          className="relative z-10 max-w-[360px] text-[14px] leading-5 text-[#546A83]"
          data-testid="nova-empty-state-description"
          id={descriptionId}
          {...getFadeUpMotionProps(prefersReducedMotion, 0.6)}
        >
          {message || DEFAULT_GREETING_MESSAGE}
        </motion.p>
      </motion.div>
    </section>
  );
}
